import { atom, selector } from "recoil";

export const topTitleState = atom({
  key: "topTitleState",
  default: "",
});
